import React, { useState } from "react";
import { CREATE, useClient, getSchemaFromResource } from "@peracto/client";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/pro-regular-svg-icons/faArrowCircleLeft";

import { Heading } from "@peracto/peracto-ui";
import { Link, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import sharedYupFields from "../sharedYupFields";
import { useAuth } from "@peracto/peracto-auth";
import { canEditIbtConfig, formatDataForApi, getIbtConfigViolations, setViolationFieldErrors, showLocationSaveErrorToasts } from "../util";

export const LocationsAdd = ({ LocationsForm }) => {
    const { client, getResource } = useClient();
    const { user } = useAuth();
    const [redirect, setRedirect] = useState("");

    const schema = getSchemaFromResource(getResource("locations")).shape(
        sharedYupFields
    );

    const onSubmit = async (data, actions) => {
        actions.setStatus(undefined);

        try {
            const response = await client(CREATE, "locations", {
                data: formatDataForApi(data, {
                    canEditIbt: canEditIbtConfig(user),
                }),
            });

            setRedirect(response.data.id);
            toast.success("Location successfully added!");
            actions.setSubmitting(false);
        } catch (e) {
            const violations = e?.error?.body?.violations || [];
            let ibtConfigViolations = [];

            if (violations.length > 0) {
                // Display errors for invalid fields.
                actions.setSubmitting(false);
                setViolationFieldErrors(actions.setFieldError, violations);

                // Kept separately (not just via setFieldError) so the IBT
                // section's error summary can be built from the raw
                // propertyPath/message pairs without depending on Formik's
                // errors shape, which can't hold both an indexed
                // (ibtConfig[0].branchSequence[0]) and whole-set (ibtConfig)
                // violation on the same key at once.
                ibtConfigViolations = getIbtConfigViolations(violations);
                if (ibtConfigViolations.length > 0) {
                    actions.setStatus({ ibtConfigViolations });
                }
            }
            console.error(e);
            showLocationSaveErrorToasts(e, violations);
            actions.setSubmitting(false);
        }
    };

    return (
        <>
            {redirect && <Redirect to={redirect} />}

            <Helmet>
                <title>Locations | Add | Peracto</title>
            </Helmet>
            <div className="form-container">
                <Heading name="Add Location">
                    <div className="flex-grow-1 d-flex align-items-center justify-content-end">
                        <Link
                            className="btn btn-outline-primary"
                            to="/locations"
                        >
                            <FontAwesomeIcon
                                icon={faArrowCircleLeft}
                                className="mr-2"
                            />
                            Back to Locations
                        </Link>
                    </div>
                </Heading>
                <LocationsForm modeAdd onSubmit={onSubmit} schema={schema} />
            </div>
        </>
    );
};
